import classNames from "@casino/external/classNames";
import type { ComponentProps } from "react";

const Container: FC<ComponentProps<"div">> = ({ className, ...props }) => (
  <div
    className={classNames(
      "w-full max-w-[73.25rem] min-[1500px]:w-[73.25rem] grid gap-2",
      className,
    )}
    {...props}
  />
);

export default Container;
